import React, { useState } from 'react';

import { inject, observer } from 'mobx-react'

import Icon from '@components/Icon'
import { InputSearch, TabPane, Tabs } from '@element/index';
import useAuthSession from '@lib/hooks/useAuthSession';
import { useIsomorphicLayoutEffect } from '@lib/hooks/useIsomorphicLayoutEffect';
import pubsub from '@lib/scripts/pubsub'
import I18n from '@utils/i18n';
import ListH5 from '@widget/market/TradeList/ListH5';
import { getListData } from '@widget/market/TradeList/utils';

import DefaultListItem from './DefaultListItem';
// import { addFavoriteKey } from '../TradeList/utils'
import OptionaTab from './OptionaTab'

import styles from './index.module.css';

export const CONTENT_TYPE = {
  DEFAULT: 'DEFAULT',
  SEARCH: 'SEARCH',
  EMPTY: 'EMPTY'
}

const DefaultList = (props) => {
  const { baseCurrenciesList, loading, setVisible, marketStore } = props;
  const isLogin = useAuthSession({ redirectTo: null });
  return (
    <div className={styles.searchPopContainer}>
      <Tabs type='marketTab'
        defaultActiveKey='0' >
        <TabPane
          tab={<div><Icon name="star" />{I18n.t('eqxdjKSN')}</div>}
          key={'collect'} type='marketTab'
          className={styles.tabPane}
        >

          <OptionaTab
            type='drawer'
            showEdit={false}
            showCollection={true}
            className={styles.optionTabs}
            tradePairDataSource={getListData('ALL', marketStore, {
              listType: 'favoriteList',
              isLogin
            })}
            setDrawerVisible={setVisible}
          />
        </TabPane>
        {baseCurrenciesList.map((tab, index) => {
          return (
            <TabPane tab={tab?.currency} key={index} type='tradeDrawer' className={styles.tabPane}>
              <DefaultListItem
                tab={tab}
                loading={loading}
                setDrawerVisible={setVisible}
              />
            </TabPane>
          )
        })}
      </Tabs>
    </div>
  );
}

const SearchList = (props) => {
  const {
    dataSource, setVisible
  } = props;

  return (
    <div className={styles.searchListContainer}>
      <ListH5
        dataSource={dataSource}
        loading={false}
        type='drawer'
        setDrawerVisible={setVisible}
        showFavorite={true}
        onItemClickCallBack={() => pubsub.publish('TRADE_DRAWER_CLOSE')}
      />
    </div>
  )
}

const EmptyList = (props) => (
  <div className={styles.searchEmpty}>
    <span className={styles.emptyText}>{I18n.t('not.found')}</span>
  </div>
)

function List (props) {
  const { listType = CONTENT_TYPE.DEFAULT, baseCurrenciesList, loading, filterSearchList, setVisible, marketStore } = props;
  if (listType === CONTENT_TYPE.DEFAULT) {
    return <DefaultList
      baseCurrenciesList={baseCurrenciesList}
      loading={loading}
      setVisible={setVisible}
      marketStore={marketStore}
    />
  } else if (listType === CONTENT_TYPE.SEARCH) {
    return <SearchList
      dataSource={filterSearchList}
      setVisible={setVisible}
    />
  } else {
    return <EmptyList />
  }
}

function SearchDrawer (props) {
  const { marketStore = {}, setVisible, tradeStore: { fetchFavoriteList }, userStore: { isLogin } } = props;
  const { baseCurrenciesList = [], fetchMarketCoin, fetchBaseCurrencies, fullMarketSymbols } = marketStore;

  const [loading, setloading] = useState(false)
  const [inputVal, setInputVal] = useState('');
  const [listType, setListType] = useState(CONTENT_TYPE.DEFAULT);
  const [filterSearchList, setfilterSearchList] = useState([]);

  const onInputChange = (e) => {
    const text = e.target.value;
    setInputVal(text);
    const marketSymbolsTypeList = getListData('ALL', marketStore);

    const matchList = marketSymbolsTypeList
      .filter((marketItem, index) =>
        marketItem.coinCode.replace('_', '/').includes(text) ||
        marketItem.coinCode.replace('_', '/').includes((text || '').toUpperCase()));
    const selectData = matchList.map(item => ({ ...item, symbol: item.coinCode }))
    if (text.length === 0) {
      setListType(CONTENT_TYPE.DEFAULT)
      setfilterSearchList([])
    } else if (selectData.length > 0) {
      setListType(CONTENT_TYPE.SEARCH)
      setfilterSearchList(selectData)
    } else if (selectData.length === 0) {
      setListType(CONTENT_TYPE.EMPTY)
      setfilterSearchList([])
    }
  }

  useIsomorphicLayoutEffect(() => {
    async function fetchData () {
      setloading(true)
      const basePromiseArr = [fetchMarketCoin(), fullMarketSymbols(), fetchBaseCurrencies()
        // fetchOptionalList()
      ]
      const promiseArr = isLogin
        ? [...basePromiseArr, fetchFavoriteList()]
        : basePromiseArr;
      await Promise.allSettled(promiseArr)
      setloading(false)
    }
    fetchData()
  }, [])

  return (
    <div className={styles.container}>
      <div className={styles.inputBg}>
        <div className={styles.inputContainer}>
          <InputSearch
            type="text"
            showClear={true}
            className={styles.searchInput}
            placeholder={I18n.t('ARqjYkin')}
            onChange={onInputChange}
            value={inputVal}
            disabled={loading}
          />
        </div>
      </div>
      {/* <SearchDrawerContext.Provider value={{ symbols }}> */}
      <div className={styles.list}>
        <List
          listType={listType}
          baseCurrenciesList={baseCurrenciesList}
          marketStore={marketStore}
          loading={loading}
          filterSearchList={filterSearchList}
          setVisible={setVisible}
        />
      </div>
      {/* </SearchDrawerContext.Provider> */}
    </div>
  );
}
export default inject(rootStore => ({
  marketStore: rootStore.store.marketStore,
  tradeStore: rootStore.store.tradeStore,
  userStore: rootStore.store.userStore
}))(observer(SearchDrawer))
